module.exports = __webpack_public_path__ + "resources/kurfs/girl-and-boy.svg";